import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  Pipe,
  PipeTransform
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {InformationFieldsControllerService, RequestControllerService, TemplateControllerService} from '../../services';
import {Request} from '../../models/request';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AssetType, Configuration, InfoFieldWrapper, InformationfieldConfiguration} from '../../models';
import {DropDownElement} from '../../drop-down-element';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {TemplateDialogComponent} from '../template-dialog/template-dialog.component';
import {UtilityService} from '../../utility.service';
import {TranslatePipe} from '../../translation/translate.pipe';
import {TranslateService} from '../../translation/translate.service';
import {PreConfiguration} from '../../models/pre-configuration';
import {RequireMatch} from '../../requireMatch';
import {DateAdapter} from '@angular/material/core';
import {Moment} from 'moment';
import * as moment from 'moment';

@Pipe({name: 'enumToArray'})
export class EnumToArrayPipe implements PipeTransform {
  transform(value): any {
    return Object.keys(value).filter(e => !isNaN(+e)).map(o => {
      return {index: +o, name: value[o]};
    });
  }
}
declare var tinymce: any;
declare var $: any;
@Component({
  selector: 'app-configurator',
  templateUrl: './configurator.component.html',
  styleUrls: ['./configurator.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class ConfiguratorComponent implements OnInit {
  id: string;
  private sub: any;
  request: Request;
  configuration: Configuration;
  validTillDate: Moment;
  selectedAssetType: AssetType;
  authenticationOptions: string[] = ['NONE', 'CELUM_LOGIN'];
  duplicateStrategyOptions: {}[] = ['DO_NOTHING', 'FILENAME', 'CHECKSUM', 'FILENAME_OR_CHECKSUM'];
  onDuplicateStrategyOptions: {}[] = ['DO_NOTHING', 'CREATE_DUPLICATE', 'CREATE_NEW_VERSION'];
  saveModeOptions: string[] = ['CREATE_FOLDER', 'CHOOSE_FOLDER', 'CREATE_OR_CHOOSE'];
  maxFilesPeriods: string[] = ['MINUTE', 'HOUR', 'DAY', 'WEEK', 'MONTH', 'YEAR', 'UNLIMITED'];
  fileCategoryOptions: string[] = ['UNKNOWN', 'DOCUMENT', 'IMAGE', 'VIDEO', 'AUDIO', 'TEXT'];
  uploaderPresetInfofieldOptions: string[];
  informationFieldOptionsMap: { [key: string]: InfoFieldWrapper; };
  informationFieldOptions: any;
  informationFieldOptionsList: {text: string, value: number}[];
  assetTypeOptions;
  defaultValueOptions: any[] = [];
  infoFieldControls: FormControl[] = [];
  defaultValueControls: FormControl[] = [];
  defaultValueSelectizeConfigs: {}[] = [];
  editMode: boolean;
  nodeId: number;
  strictNode: boolean;
  nameCtrl: FormControl = new FormControl();
  duplicateCtrl: FormControl = new FormControl();
  guiLanguage = 'en';
  brandingOptions;
  languageOptions = ['en', 'de'];
  configForm = new FormGroup({
    name: new FormControl('', Validators.required)
  });
  firstRequest = false;
  defaultLanguage: string;
  preConfiguration: PreConfiguration;
  infofieldControls = [];
  filteredOptions: any;
  fieldsetOptions: any;
  filteredFieldSets: any;
  creatorChanged: boolean;
  targetNodeChanged: boolean;
  createInNodeSelectizeConfig = {
    create: false,
    valueField: 'id',
    labelField: 'name',
    delimiter: '|',
    maxItems: 1,
    required: true,
    closeAfterSelect: false,
    searchField: 'name',
    dropdownParent: 'body',
    dropdownDirection: 'up',
    render: {
      option(item, escape) {
        let template = '<div>';
        if (item.parents) {
          item.parents.forEach(parent => {
            template += '<span class="parent-noderef">' + parent + ' - </span> ';
          });
        }
        template += '<span>' + item.name + '</span></div>';
        return template;
      }
    },
  };
  public infoFieldInitialized: any[];
  editor;
  uploaderInformation = '';

  constructor(private route: ActivatedRoute,
              private requestService: RequestControllerService,
              private templateService: TemplateControllerService,
              private infoFieldsService: InformationFieldsControllerService,
              private fb: FormBuilder,
              private snackBar: MatSnackBar,
              private router: Router,
              public templateDialog: MatDialog,
              private utilityService: UtilityService,
              public translatePipe: TranslatePipe,
              private translateService: TranslateService,
              private activatedRoute: ActivatedRoute,
              private dateAdapter: DateAdapter<Date>,
              private cdr: ChangeDetectorRef) {
    this.guiLanguage = this.translateService.currentLang;
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(queryParams => {
      this.requestService.getConfigUsingGET().subscribe(configuration => {
        this.preConfiguration = configuration;
        this.firstRequest = queryParams['firstRequest'];
        this.requestService.listBrandingsUsingGET().subscribe(brandings => {
          this.brandingOptions = brandings;
        });
        this.infoFieldsService.languagesUsingGET(this.guiLanguage).subscribe(languages => {
          this.defaultLanguage = languages['defaultLanguage'];
        });
        this.nodeId = this.utilityService.getNodeId();
        this.strictNode = this.utilityService.isNodeStrict();
        this.sub = this.route.params.subscribe(params => {
          this.editMode = this.router.url.includes('/config/edit');
          if (params.id !== undefined) {
            this.id = params.id;
            this.requestService.getRequestUsingGET(params.id).subscribe(res => {
              this.request = res;
              this.configuration = res.configuration;
              this.cdr.detectChanges();
              if ((this.configuration && this.configuration.assetType) || this.preConfiguration.defaultAssetType) {
                const assetType = (this.configuration && this.configuration.assetType) ? this.configuration.assetType :
                  this.preConfiguration.defaultAssetType['id'];
                this.infoFieldsService.infoFieldsByAssetTypeUsingGET(assetType).subscribe(infoFieldOptions => {
                  this.infoFieldsService.fieldSetsByAssetTypeUsingGET(assetType).subscribe(fieldSets => {
                    if (this.preConfiguration.informationFields == null) {
                      this.fieldsetOptions = fieldSets;
                    } else {
                      this.fieldsetOptions = [];
                      fieldSets.forEach(fieldSet => {
                        const filteredInfofields = fieldSet.informationFields.filter(infofield => {
                          return this.preConfiguration.informationFields.includes(infofield.id.id);
                        });
                        if (filteredInfofields.length > 0) {
                          this.fieldsetOptions.push({labels: fieldSet.labels, informationFields : filteredInfofields});
                        }
                      });
                    }
                    this.filteredFieldSets = this.fieldsetOptions;
                    this.informationFieldOptionsMap = infoFieldOptions;
                    this.informationFieldOptions = Object.values(infoFieldOptions);
                    this.filteredOptions = this.informationFieldOptions;
                    this.defaultValueOptions = new Array(this.configuration.informationFields.length);
                    this.infoFieldControls = new Array(this.configuration.informationFields.length);
                    this.infofieldControls = new Array(this.configuration.informationFields.length);
                    this.defaultValueControls = new Array(this.configuration.informationFields.length);
                    this.defaultValueSelectizeConfigs = new Array(this.configuration.informationFields.length);
                    this.infoFieldInitialized = new Array(this.configuration.informationFields.length);
                    this.prepareInfofieldOptions(infoFieldOptions);
                    this.configuration.informationFields.forEach((infoFieldConfig, i) => {
                      this.initializeInfoFieldConfig(infoFieldConfig, i);
                    });
                  });
                });
              }
              if (!this.configuration.uploaderInformation) {
                this.configuration.uploaderInformation = {};
              }
              if (!this.configuration.maxFilesPeriod) {
                this.configuration.maxFilesPeriod = 'UNLIMITED';
                this.request.configuration.maxFilesPeriod = 'UNLIMITED';
              }
              if (this.configuration.name != null) {
                this.nameCtrl.setValue(this.configuration.name);
              }
              if (this.configuration.validTill != null && this.configuration.validTill > 0 ) {
                this.validTillDate = moment(new Date(this.configuration.validTill));
              }
              this.getAssetTypes();
            });
          } else {
            this.configuration = new class implements Configuration {
              assetType: number;
              authenticationMode: 'NONE' | 'CELUM_LOGIN' = 'NONE';
              duplicateHandling: 'DO_NOTHING' | 'CREATE_DUPLICATE' | 'CREATE_NEW_VERSION' = 'CREATE_DUPLICATE';
              duplicateStrategy: 'DO_NOTHING' | 'CHECKSUM' | 'FILENAME' | 'FILENAME_OR_CHECKSUM' = 'CHECKSUM';
              fileCategory: Array<'UNKNOWN' | 'IMAGE' | 'DOCUMENT' | 'VIDEO' | 'AUDIO' | 'TEXT'> =
                ['UNKNOWN', 'IMAGE', 'DOCUMENT', 'VIDEO', 'AUDIO', 'TEXT'];
              id: number;
              informationFields: Array<InformationfieldConfiguration>;
              maxFileSizeMB: number;
              maxFiles: number;
              name: string;
              saveMode: 'CREATE_FOLDER' | 'CHOOSE_FOLDER' | 'CREATE_OR_CHOOSE' = 'CREATE_FOLDER';
              searchDuplicatesEverywhere: boolean;
              uploaderPresetInfoField: number;
              validTill: number;
              maxFilesPeriods: string[] = ['MINUTE', 'HOUR', 'DAY', 'WEEK', 'MONTH', 'YEAR', 'UNLIMITED'];
              uploaderInformation = {};
              autoUploadOption: boolean;
            }();
            this.configuration.assetSpecificMetadata = !this.preConfiguration.sameMetadataEveryAsset;
            if (this.preConfiguration.autoUploadDefault) {
              this.configuration.autoUploadOption = true;
            }
            this.configuration.assetSpecificMetadata = !this.preConfiguration.sameMetadataEveryAsset;
            this.configuration.maxFilesPeriod = 'UNLIMITED';
            this.getAssetTypes();
            this.configuration.informationFields = [];
            this.addInformationFieldsRow(0);
            if (this.configuration.validTill != null && this.configuration.validTill > 0 ) {
              this.validTillDate = moment(new Date(this.configuration.validTill));
            } else if (this.preConfiguration.validityDefault) {
              this.validTillDate  = moment(new Date(new Date().getTime() + (this.preConfiguration.validityDefault * 3600 * 1000 * 24)));
            }
            this.cdr.detectChanges();
          }
          if (this.configuration) {
            if (this.preConfiguration.brandingDefault != null) {
              this.configuration.branding = this.preConfiguration.brandingDefault;
            }
            if (this.preConfiguration.languageDefault != null) {
              this.configuration.language = this.preConfiguration.languageDefault;
            }
            if (this.preConfiguration.saveModeOptionsDefault != null) {
              this.configuration.saveMode = this.preConfiguration.saveModeOptionsDefault;
            }
            if (this.preConfiguration.authenticationDefault != null) {
              this.configuration.authenticationMode = this.preConfiguration.authenticationDefault;
            }
            if (this.preConfiguration.duplicateHandling != null) {
              this.configuration.duplicateHandling = this.preConfiguration.duplicateHandlingDefault;
            }
            if (this.preConfiguration.disclaimerDefault != null) {
              this.configuration.showDisclaimer = this.preConfiguration.disclaimerDefault;
            }
          }
        });
        this.uploaderPresetInfofieldOptions = [];
      });
    });
  }

  displayFn = value => {
    if (value && value.labels && value.labels.values) {
      return value.labels.values[this.guiLanguage] ? value.labels.values[this.guiLanguage] : value.labels.values[this.defaultLanguage];
    }
  }


  getAssetTypes() {
    this.infoFieldsService.assetTypesUsingGET().subscribe(assetTypes => {
      if (this.preConfiguration.assetTypes != null) {
        this.assetTypeOptions = assetTypes.filter(assetType => {
          return this.preConfiguration.assetTypes.includes(assetType.id.id);
        });
      } else {
        this.assetTypeOptions = assetTypes;
      }
      this.assetTypeOptions.forEach(assetType => {
        if (assetType.id.id === this.configuration.assetType ||
          (!this.configuration.assetType &&
            (assetType && assetType.id && this.preConfiguration.defaultAssetType &&
              assetType.id.id === this.preConfiguration.defaultAssetType['id']))) {
          this.selectedAssetType = assetType;
          this.changeAssetType(assetType);
          if (this.configuration.informationFields.length === 0) {
            this.addInformationFieldsRow(0);
          }
        }
      });
    });
  }

  addChildOptions(options, node, parentName, parentNames) {
    const lang = this.guiLanguage !== undefined ? this.guiLanguage : this.defaultLanguage;
    const nodeName = node.name.values[lang] !== undefined ? node.name.values[lang] : node.name.values[this.defaultLanguage];
    let newParentNames;
    if (parentName != null) {
      newParentNames = parentNames;
    } else {
      newParentNames = [];
    }
    const parentNameCopy = parentNames.slice();
    options.push({id: 'id_' + node.id.id, name: nodeName, parents: parentNameCopy});
    if (node.children != null && node.children.length > 0) {
      newParentNames.push(nodeName);
      node.children.forEach(child => {
        this.addChildOptions(options, child, nodeName, newParentNames);
      });
    }
    return options;
  }

  addInformationFieldsRow(index) {
    this.configuration.informationFields.splice(index, 0,
      new class implements InformationfieldConfiguration {
        defaultValue: any;
        informationfieldId: number;
        locked: boolean;
        required: boolean;
        // tslint:disable-next-line:max-line-length
        type: 'BOOLEAN' | 'DATE' | 'DOUBLE' | 'DROP_DOWN' | 'NODE_REFERENCE' | 'NUMBER' | 'TEXT' | 'TEXT_AREA' | 'LOCALIZED_TEXT' | 'LOCALIZED_TEXT_AREA';
        allowCreate: boolean;
        createInNode: string;
      }());
    this.defaultValueOptions.splice(index, 0, null);
    this.defaultValueControls.splice(index, 0, new FormControl());
    this.infoFieldControls.splice(index, 0, new FormControl());
    this.infofieldControls.splice(index, 0, new FormControl());
    this.defaultValueSelectizeConfigs.splice(index, 0, new FormControl());
  }

  removeInformationFieldsRow(index) {
    if (index > -1) {
      this.configuration.informationFields.splice(index, 1);
      this.defaultValueOptions.splice(index, 1);
      this.defaultValueControls.splice(index, 1);
      this.infoFieldControls.splice(index, 1);
      this.infofieldControls.splice(index, 1);
      this.defaultValueSelectizeConfigs.splice(index, 1);
    }
  }

  getOptionInfoFieldName(option: InfoFieldWrapper) {
    const lang = this.guiLanguage !== undefined ? this.guiLanguage : 'en';
    return option !== undefined && option !== null &&  option.infoField
    && option.infoField.labels.values[lang] ? option.infoField.labels.values[lang] : '';
  }

  getOptionName(option) {
    return option !== undefined && option !== null && option.name ? option.name : '';
  }

  getOptionLabelName(option) {
    const lang = this.guiLanguage !== undefined ? this.guiLanguage : 'en';
    return option !== undefined && option !== null && option.labels.values[lang] ? option.labels.values[lang] : '';
  }

  getOptionDisplayText(option) {
    return option && option.displayText ? option.displayText : '';
  }

  changeInfofieldSelectize(value, i) {
    if (value > 0 && this.informationFieldOptionsMap.hasOwnProperty(value)) {
      this.initializeInfoFieldConfig(this.configuration.informationFields[i], i);
      this.configuration.informationFields[i].kind = this.informationFieldOptionsMap[value].infoField.kind;
      this.configuration.informationFields[i].defaultValue = null;
      this.infoFieldControls[i].setValue(value);
    }
  }

  changeInfofield(option, i) {
    this.configuration.informationFields[i].informationfieldId = option.option.value.id.id;
    this.configuration.informationFields[i].kind = option.option.value.kind;
    this.configuration.informationFields[i].defaultValue = null;
    this.initializeInfoFieldConfig(this.configuration.informationFields[i], i);
  }

  changeAssetType(assetType) {
    this.selectedAssetType = assetType;
    if (!assetType) {
      this.configuration.informationFields = [];
    } else {
      this.infoFieldsService.infoFieldsByAssetTypeUsingGET(assetType.id.id).subscribe(infoFieldOptions => {
        this.infoFieldsService.fieldSetsByAssetTypeUsingGET(assetType.id.id).subscribe(fieldSets => {
          if (this.preConfiguration.informationFields == null) {
            this.fieldsetOptions = fieldSets;
          } else {
            this.fieldsetOptions = [];
            fieldSets.forEach(fieldSet => {
              const filteredInfofields = fieldSet.informationFields.filter(infofield => {
                return this.preConfiguration.informationFields.includes(infofield.id.id);
              });
              if (filteredInfofields.length > 0) {
                this.fieldsetOptions.push({labels: fieldSet.labels, informationFields: filteredInfofields});
              }
            });
          }
          this.filteredFieldSets = this.fieldsetOptions;
          this.informationFieldOptionsMap = infoFieldOptions;
          this.informationFieldOptions = Object.values(infoFieldOptions);
          this.filteredOptions = this.informationFieldOptions;
          this.prepareInfofieldOptions(infoFieldOptions);
          this.informationFieldOptionsMap = infoFieldOptions;
          this.informationFieldOptions = Object.values(infoFieldOptions);
          this.filteredOptions = this.informationFieldOptions;
          if (this.configuration.informationFields.length === 0) {
            this.addInformationFieldsRow(0);
          }
          this.configuration.informationFields.forEach((infoFieldConfig, i) => {
            this.defaultValueControls[i] = null;
            this.initializeInfoFieldConfig(infoFieldConfig, i);
          });
        });
      });
    }
    this.cdr.detectChanges();
  }

  prepareInfofieldOptions(infoFieldOptions) {
    this.informationFieldOptionsList = [];
    const optionsArray = Object.values(infoFieldOptions);
    for (const value of Object.values(optionsArray)) {
      if (this.preConfiguration.informationFields == null ||
        this.preConfiguration.informationFields.includes(value['infoField'].id.id)) {
        this.informationFieldOptionsList.push(
          {text: value['infoField'].labels.values[this.guiLanguage], value: value['infoField'].id.id}
        );
      }
    }
  }

  initializeInfoFieldConfig(infoFieldConfig: InformationfieldConfiguration, i) {
    const infoFieldFormControl = new FormControl();
    this.infofieldControls[i] = new FormControl('', [Validators.required, RequireMatch]);
    let defaultValueFormControl = new FormControl();
    let defaultValueOptions = null;
    if (infoFieldConfig.kind === 'DROP_DOWN' || infoFieldConfig.kind === 'NODE_REFERENCE') {
      this.defaultValueOptions[i] = null;
      this.infoFieldsService.optionsByInfoFieldUsingGET(infoFieldConfig.informationfieldId).subscribe(res => {
        defaultValueOptions = res;
        if (infoFieldConfig.kind === 'NODE_REFERENCE') {
          this.defaultValueSelectizeConfigs[i] = {
            create: false,
            valueField: 'id',
            labelField: 'name',
            delimiter: '|',
            maxItems: (this.informationFieldOptionsMap[infoFieldConfig.informationfieldId] !== undefined &&
              this.informationFieldOptionsMap[infoFieldConfig.informationfieldId].max !== -1)
              ? this.informationFieldOptionsMap[infoFieldConfig.informationfieldId].max : null,
            minItems: 1,
            required: true,
            closeAfterSelect: false,
            searchField: 'name',
            dropdownParent: 'body',
            dropdownDirection: 'up',
            render: {
              option(item, escape) {
                let template = '<div>';
                if (item.parents) {
                  item.parents.forEach(parent => {
                    template += '<span class="parent-noderef">' + parent + ' - </span> ';
                  });
                }
                template += '<span>' + item.name + '</span></div>';
                return template;
              }
            },
          };
          let options = [];
          if (this.informationFieldOptionsMap[infoFieldConfig.informationfieldId] !== undefined &&
            this.informationFieldOptionsMap[infoFieldConfig.informationfieldId].rootSelectable) {
            res.forEach(defaultValueOption => {
              options = this.addChildOptions(options, defaultValueOption, null, []);
            });
          } else {
            res.forEach(defaultValueOption => {
              const defaultValueOptionChild = defaultValueOption as any;
              defaultValueOptionChild.children.forEach(child => {
                options = this.addChildOptions(options, child, null, []);
              });
            });
          }
          if (!this.defaultValueOptions[i]) {
            this.defaultValueOptions[i] = options;
          }
          if (!this.defaultValueControls[i]) {
            this.defaultValueControls[i] = defaultValueFormControl;
          }
        } else if (infoFieldConfig.kind === 'DROP_DOWN') {
          this.defaultValueOptions[i] = res;
          this.defaultValueControls[i] = new FormControl();
          res.forEach(defaultValueOption => {
            const defaultValueOptionOption = defaultValueOption as DropDownElement;
            if (infoFieldConfig.defaultValue === defaultValueOptionOption.key ) {
              defaultValueFormControl = new FormControl(defaultValueOption);
              this.defaultValueControls[i] = defaultValueFormControl;
            }
          });
        }
        setTimeout( () => {
          this.infoFieldInitialized[i] = true;
        }, 1000 );
      });
    } else {
      this.defaultValueOptions[i] = defaultValueOptions;
      if (infoFieldConfig.kind === 'DATE') {
        if (infoFieldConfig.defaultValue != null) {
          defaultValueFormControl.setValue(new Date(Number(infoFieldConfig.defaultValue)));
          this.defaultValueControls[i] = defaultValueFormControl;
        }
      } else if (infoFieldConfig.kind === 'LOCALIZED_TEXT_AREA' || infoFieldConfig.kind === 'LOCALIZED_TEXT') {
        if (infoFieldConfig.defaultValue && infoFieldConfig.defaultValue['values'] &&
          infoFieldConfig.defaultValue['values'][this.defaultLanguage]) {
          defaultValueFormControl.setValue(infoFieldConfig.defaultValue['values'][this.defaultLanguage]);
        }
        this.defaultValueControls[i] = defaultValueFormControl;
        }
      if (!this.infoFieldInitialized) {
        this.infoFieldInitialized = new Array(this.configuration.informationFields.length);
      }
      this.infoFieldInitialized[i] = true;
    }
    if (this.informationFieldOptionsMap[infoFieldConfig.informationfieldId]) {
      infoFieldFormControl.setValue(this.informationFieldOptionsMap[infoFieldConfig.informationfieldId].infoField);
      this.infofieldControls[i].setValue(this.informationFieldOptionsMap[infoFieldConfig.informationfieldId].infoField);
    }
    this.infoFieldControls[i] = infoFieldFormControl;
  }

  valuechange(value: any) {
    if (value && typeof value === 'string') {
      const filterValue = value.toLowerCase();
      const filteredSets = [];
      this.fieldsetOptions.forEach(fieldSet => {
        const filteredInfofields = fieldSet.informationFields.filter(infofield => {
          return infofield.labels.values[this.guiLanguage].toLowerCase().includes(filterValue);
        });
        if (filteredInfofields.length > 0) {
          filteredSets.push({labels: fieldSet.labels, informationFields : filteredInfofields});
        }
      });
      this.filteredFieldSets = filteredSets;
    } else {
      this.filteredFieldSets =  this.fieldsetOptions;
    }
  }

  onSubmit() {
    if (this.isValid()) {
      if (this.defaultLanguage) {
        this.setConfiguration();
        this.submitRequest();
      } else {
        console.error('No default language found');
        this.infoFieldsService.languagesUsingGET(this.guiLanguage).subscribe(languages => {
          this.defaultLanguage = languages['defaultLanguage'];
          this.setConfiguration();
          this.submitRequest();
        });
      }
    }
  }

  submitRequest() {
    if (this.router.url.includes('/config/edit')) {
      this.requestService.updateRequestUsingPUT( this.id, this.configuration).subscribe(res => {
        if (this.preConfiguration.superadmin && this.creatorChanged && this.targetNodeChanged) {
          this.requestService.updateRequestCreatorUsingPUT(this.id, this.request.creator.id).subscribe(() => {
            this.requestService.updateRequestTargetUsingPUT(this.id, this.request.targetNode['id']).subscribe(() => {
              this.router.navigate(['/main/uploadRequest/requests']);
            });
          });
        } else if (this.preConfiguration.superadmin && this.creatorChanged) {
          this.requestService.updateRequestCreatorUsingPUT(this.id, this.request.creator.id).subscribe(() => {
            this.router.navigate(['/main/uploadRequest/requests']);
          });
        } else if (this.preConfiguration.superadmin && this.targetNodeChanged) {
          this.requestService.updateRequestTargetUsingPUT(this.id, this.request.targetNode['id']).subscribe(() => {
            this.router.navigate(['/main/uploadRequest/requests']);
          });
        } else {
          this.router.navigate(['/main/uploadRequest/requests']);
        }
      });
    } else {
      this.requestService.createRequestUsingPOST(this.nodeId, this.configuration).subscribe(res => {
        this.router.navigate(['/main/uploadRequest/requests']);
      });
    }
  }

  setConfiguration() {
    if (this.validTillDate != null) {
      this.validTillDate.set({hour: 0, minute: 0, second: 0, millisecond: 0});
      this.configuration.validTill = this.validTillDate.valueOf();
    } else {
      this.configuration.validTill = null;
    }
    this.configuration.name = this.nameCtrl.value;
    this.configuration.assetType = this.selectedAssetType !== undefined ? this.selectedAssetType.id.id : null;
    this.configuration.informationFields.forEach((infoFieldConfig, i) => {
      if (infoFieldConfig.kind === 'DATE') {
        this.configuration.informationFields[i].defaultValue = this.defaultValueControls[i] && this.defaultValueControls[i].value !== null ?
          this.defaultValueControls[i].value.valueOf() : null;
      } else if (infoFieldConfig.kind === 'LOCALIZED_TEXT_AREA' || infoFieldConfig.kind === 'LOCALIZED_TEXT') {
        if (this.defaultValueControls[i] && this.defaultValueControls[i].dirty) {
          const localizedValue: any = {values: {}};
          localizedValue.values[this.defaultLanguage] = this.defaultValueControls[i].value;
          this.configuration.informationFields[i].defaultValue = localizedValue;
        }
      } else if (infoFieldConfig.kind === 'DROP_DOWN' && this.defaultValueControls[i].value) {
        this.configuration.informationFields[i].defaultValue = this.defaultValueControls[i].value.key;
      }
    });
    this.configuration.informationFields = this.configuration.informationFields.filter(config => {
      return config.informationfieldId !== undefined && config.informationfieldId != null;
    });
  }

  isValid() {
    let valid: boolean;
    this.nameCtrl.markAllAsTouched();
    this.duplicateCtrl.markAllAsTouched();
    valid = this.nameCtrl.valid && (this.configuration.duplicateStrategy === 'DO_NOTHING' || this.duplicateCtrl.valid);
    if (!valid) {
      this.snackBar.open(this.translatePipe.transform('FILL_ALL_REQUIRED_FIELDS'), this.translatePipe.transform('INVALID_FORM'), {
        duration: 2000,
      });
    }
    return valid;
  }

  openTemplateDialog() {
    const templateDialogRef = this.templateDialog.open(TemplateDialogComponent,
      {width: '1250px', data: {groupDeleteTemplate: this.preConfiguration ? this.preConfiguration.groupDeleteTemplate : false}});
    templateDialogRef.afterClosed().subscribe(result => {
      if (result != null) {
        this.snackBar.open(this.translatePipe.transform('TEMPLATE ') + ' ' + result.name + this.translatePipe.transform('LOADED'),
          this.translatePipe.transform('TEMPLATE_LOADED'), {
            duration: 2000,
          });
        this.configuration = result;
        if (!this.configuration.uploaderInformation) {
          this.configuration.uploaderInformation = {};
        }
        if (this.configuration.assetType || this.preConfiguration.defaultAssetType) {
          this.assetTypeOptions.forEach( assetType => {
            if (assetType.id.id === this.configuration.assetType ||
              (!this.configuration.assetType && (assetType.id.id === this.preConfiguration.defaultAssetType['id']))) {
              this.changeAssetType( assetType);
            }
          });
        }
      }
    });
  }

  saveAsTemplate() {
    if (this.isValid()) {
      this.setConfiguration();
      this.templateService.createTemplateUsingPOST( this.configuration).subscribe(res => {
        this.snackBar.open(this.translatePipe.transform('CONFIGURATION ') + ' ' +
          this.configuration.name + ' ' + this.translatePipe.transform('SAVED_AS_TEMPLATE'),
          this.translatePipe.transform('TEMPLATE_SAVED'), {
            duration: 2000,
          });
      });
    }
  }

  fieldChangedModel($event, index) {
    if (!this.configuration.informationFields[index].defaultValue || this.configuration.informationFields[index].defaultValue === '' ||
      (this.configuration.informationFields[index].kind === 'NODE_REFERENCE' &&
        ((this.isArray($event) &&
          $event['length'] === 0) || !$event))) {
      this.configuration.informationFields[index].locked = false;
    }
  }

  fieldChangedControl(index) {
    if (this.defaultValueControls[index].touched &&
      (!this.defaultValueControls[index].value || this.defaultValueControls[index].value === '')) {
      this.configuration.informationFields[index].locked = false;
    }
    this.cdr.detectChanges();
  }

  isArray(defaultValue) {
    return Array.isArray(defaultValue);
  }

  autoUploadToggle() {
    if (this.configuration.autoUploadOption) {
      this.configuration.saveMode = 'CHOOSE_FOLDER';
    }
  }

}
